// extracted by mini-css-extract-plugin
export var buttons = "_ab-0";
export var buttonsActive = "_ab-h";
export var cancelConfirm = "_ab-1";
export var closeButton = "_ab-2";
export var column = "_ab-3";
export var container = "_ab-4";
export var detailHeader = "_ab-6";
export var detailTitle = "_ab-7";
export var detailsContent = "_ab-5";
export var header = "_ab-8";
export var headerWithClose = "_ab-9";
export var icon = "_ab-a";
export var infoIcon = "_ab-c";
export var informationContainer = "_ab-b";
export var sideDrawer = "_ab-d";
export var sideDrawerOpen = "_ab-e";
export var stickyFooter = "_ab-f";
export var typeOption = "_ab-g";